(ns frontend.view.nev.kyc.process.string-array-editor
  (:require
   [ui.editors.data-input :as data-input]
   [ui.components.button.view :as button]
   [common.localization :as loc]
   [reagent.core :as r]
   [common.util :as cu]
   [clojure.string :as string]))

(defn view
  [_args]
  (let [local-state* (r/atom {:temp-value ""
                              :edit-index nil
                              :edit-temp ""
                              :error nil})]
    (fn [{:keys [question-attribute question-meta lang-kw answers-atom save!]
          :or {lang-kw :en}
          :as _args}]
      (let [label (get-in question-meta [:translations lang-kw])
            placeholder (get-in question-meta [:placeholder lang-kw])
            value (get @answers-atom question-attribute [])
            normalize (fn [s]
                        (-> (or s "")
                            cu/str-trim
                            string/lower-case))
            add-item (fn []
                       (let [prev (get @answers-atom question-attribute [])
                             new-item (-> @local-state* :temp-value cu/str-trim)
                             new-item-norm (normalize new-item)
                             existing-norms (set (map normalize prev))]
                         (cond
                           (cu/blank-value? new-item)
                           (swap! local-state* assoc :error nil)

                           (contains? existing-norms new-item-norm)
                           (swap! local-state* assoc :error (loc/tr :duplicate-values-not-allowed))

                           :else
                           (do
                             (swap! answers-atom assoc question-attribute (conj (vec prev) new-item))
                             (deref answers-atom)
                             (save!)
                             (swap! local-state* assoc :temp-value "" :error nil)))))
            delete-item (fn [index]
                          (let [prev (vec (get @answers-atom question-attribute []))
                                new-val (into [] (concat (subvec prev 0 index)
                                                         (subvec prev (inc index))))]
                            (swap! answers-atom assoc question-attribute new-val)
                            (deref answers-atom)
                            (save!)
                            (when (= (:edit-index @local-state*) index)
                              (swap! local-state* assoc :edit-index nil :edit-temp "" :error nil))))
            start-edit (fn [index item]
                         (swap! local-state* assoc :edit-index index :edit-temp item :error nil))
            save-edit (fn [index]
                        (let [prev (get @answers-atom question-attribute [])
                              edited (-> @local-state* :edit-temp cu/str-trim)
                              edited-norm (normalize edited)
                              existing-norms (->> prev
                                                  (map-indexed vector)
                                                  (remove (fn [[i _]] (= i index)))
                                                  (map (fn [[_ v]] (normalize v)))
                                                  set)]
                          (cond
                            (cu/blank-value? edited)
                            (swap! local-state* assoc :error (loc/tr :value-cannot-be-empty))

                            (contains? existing-norms edited-norm)
                            (swap! local-state* assoc :error (loc/tr :duplicate-values-not-allowed))

                            :else
                            (let [updated (assoc (vec prev) index edited)]
                              (swap! answers-atom assoc question-attribute updated)
                              (deref answers-atom)
                              (save!)
                              (swap! local-state* assoc :edit-index nil :edit-temp "" :error nil)))))
            cancel-edit (fn [] (swap! local-state* assoc :edit-index nil :edit-temp "" :error nil))]
        [:div {:class "flex flex-col gap-1.5"}
         [:label {:class "text-[14px] text-input-light-text font-semibold"} label]


         [:div {:class "flex flex-col gap-1"}
          (->> value
               (map-indexed
                (fn [index item]
                  (let [editing? (= index (:edit-index @local-state*))]
                    ^{:key (str item "-" index)}
                    [:div
                     {:class "flex items-center justify-between gap-2 border border-gray-200 rounded px-2 py-1"}
                     [:div {:class (str "grow min-w-0 " (when (not editing?) "truncate"))}
                      (if editing?
                        [data-input/view
                         {:value (:edit-temp @local-state*)
                          :data-type :data.type/text-simple
                          :on-change (fn [v] (swap! local-state* assoc :edit-temp v))
                          :class "w-full"}]
                        [:span item])]
                     [:div {:class "flex items-center gap-1 shrink-0"}
                      (if editing?
                        [button/sm-secondary-hollow
                         {:on-click #(save-edit index)}
                         [:i {:class "fal fa-check"}]
                         (loc/tr :save)]
                        [button/square-secondary-hollow
                         {:on-click #(start-edit index item)}
                         [:i {:class "fal fa-pencil"}]])
                      (if editing?
                        [button/sm-secondary-hollow
                         {:on-click cancel-edit}
                         [:i {:class "fal fa-times"}]
                         (loc/tr :cancel)]
                        [button/square-danger-hollow
                         {:on-click #(delete-item index)}
                         [:i {:class "fal fa-trash"}]])]])))
               doall)]


         [:div {:class "flex gap-1"}
          [data-input/view
           (merge
            {:value (:temp-value @local-state*)
             :data-type :data.type/text-simple
             :on-change (fn [value] (swap! local-state* assoc :temp-value value :error nil))
             :class "grow"}
            (when placeholder {:placeholder placeholder}))]
          [:div {:class "flex"}
           [button/sm-primary-solid
            {:on-click add-item}
            [:i {:class "fal fa-plus"}]
            (loc/tr :add)]]

          (when-let [err (:error @local-state*)]
            [:div {:class "text-red-500 text-xs mt-1"} err])]]))))
